import { useMemo } from "react";
import { HgProduct } from "../../../../types/taxonomy";

export const useFilteredProducts = (
  products: HgProduct[],
  searchTerm: string
) =>
  useMemo(() => {
    if (products && searchTerm && searchTerm.length >= 2) {
      return products
        .filter(({ name }) => name.toLowerCase().includes(searchTerm))
        .sort((a, b) => {
          const aName = a.name.toLowerCase();
          const bName = b.name.toLowerCase();

          const diff =
            aName.indexOf(searchTerm) - bName.toLowerCase().indexOf(searchTerm);

          return diff || aName.localeCompare(bName);
        });
    }

    return [];
  }, [products, searchTerm]);
